import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { nbsApiGetConfig } from '../../store/actions/getConfig';
import { nbsApiGetSearchControls } from '../../store/actions/getSearchControls';
import { nbsApiGetProfileControls } from '../../store/actions/getProfileControls';
import { nbsApiGetSubscriptionsList } from '../../store/actions/getSubscriptionsList';
import { nbsApiEditProfile } from '../../store/actions/editProfile';
import { getStoredLanguage, setStoredLanguage } from '../../store/actions/language';
import LanguageSwitch from '../../components/LanguageSwitch/LanguageSwitch';
import strings from '../../assets/localization';

class LanguageSwitchContainer extends Component {
  constructor (props) {
    super(props);

    this.state = { showList: false };
    if (this.props.language.code === '' && this.props.language.isFetching === false) {
      this.props.getStoredLanguage();
    }
  }

  toggleLanguageList = () => {
    this.setState(state => ({
      showList: !state.showList
    }));
  }
  changeLanguage = (langCode) => {
    this.setState({ showList: false });
    if (langCode !== strings.getLanguage()) {
      this.props.setStoredLanguage(langCode);
      let data = { language: langCode };
      strings.setLanguage(langCode);
      if (this.props.session.token) {
        data.sess_token = this.props.session.token;
      }
      this.props.nbsApiGetConfig(data);
      if (data.sess_token) {
        this.props.nbsApiEditProfile(data);
        this.props.nbsApiGetSubscriptionsList({ ...data, platform: 'web' });
        this.props.nbsApiGetSearchControls({ ...data, type: 'search' });
        this.props.nbsApiGetProfileControls({ ...data, type: 'profile' });
      }
    }
  }

  render () {
    return (
      <LanguageSwitch
        selected={strings.getLanguage()}
        getConfig={this.props.getConfig}
        showList={this.state.showList}
        toggleLanguageList={this.toggleLanguageList}
        changeLanguage={this.changeLanguage}
      />
    );
  }
}

function mapStateToProps (state) {
  return {
    language: state.language,
    session: state.session,
    getConfig: state.getConfig,
    getMyProfile: state.getMyProfile
  };
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    getStoredLanguage,
    setStoredLanguage,
    nbsApiGetSearchControls,
    nbsApiGetProfileControls,
    nbsApiGetSubscriptionsList,
    nbsApiGetConfig,
    nbsApiEditProfile
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSwitchContainer);
